import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Anuncios from './pages/Anuncios';
import AnuncioDetalhe from './pages/AnuncioDetalhe';
import CriarAnuncio from './pages/CriarAnuncio';
import MeusAnuncios from './pages/MeusAnuncios';
import Perfil from './pages/Perfil';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import Planos from './pages/Planos';
import Favoritos from './pages/Favoritos';
import AdminDashboard from './pages/Admin/Dashboard';

// Páginas Institucionais
import Sobre from './pages/Sobre';
import ComoFunciona from './pages/ComoFunciona';
import Contato from './pages/Contato';
import Blog from './pages/Blog';
import FAQ from './pages/FAQ';
import Ajuda from './pages/Ajuda';
import Termos from './pages/Termos';
import Privacidade from './pages/Privacidade';
import Seguranca from './pages/Seguranca';
import Cookies from './pages/Cookies';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: '#22c55e',
            },
          },
          error: {
            style: {
              background: '#ef4444',
            },
          },
        }}
      />
      <Header />
      <main className="flex-1">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrar" element={<Register />} />
          <Route path="/anuncios" element={<Anuncios />} />
          <Route path="/anuncios/:id" element={<AnuncioDetalhe />} />
          <Route path="/planos" element={<Planos />} />
          
          {/* Páginas Institucionais */}
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/como-funciona" element={<ComoFunciona />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/ajuda" element={<Ajuda />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/seguranca" element={<Seguranca />} />
          <Route path="/cookies" element={<Cookies />} />

          {/* Protected Routes */}
          <Route path="/criar-anuncio" element={
            <ProtectedRoute>
              <CriarAnuncio />
            </ProtectedRoute>
          } />
          <Route path="/meus-anuncios" element={
            <ProtectedRoute>
              <MeusAnuncios />
            </ProtectedRoute>
          } />
          <Route path="/perfil" element={
            <ProtectedRoute>
              <Perfil />
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/chat" element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          } />
          <Route path="/chat/:conversaId" element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          } />
          <Route path="/favoritos" element={
            <ProtectedRoute>
              <Favoritos />
            </ProtectedRoute>
          } />

          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <AdminDashboard />
            </ProtectedRoute>
          } />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
